var render, staticRenderFns
import script from "./supplementDetail.vue?vue&type=script&lang=js"
export * from "./supplementDetail.vue?vue&type=script&lang=js"
import style0 from "./supplementDetail.vue?vue&type=style&index=0&id=150c4dac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c4dac",
  null
  
)

export default component.exports